import type { LeadFieldsPatch } from '@viq-admin/screens';
import type { LeadFieldsUpdateResponse } from '@viq-admin/types';
import { superadminFetch } from './dataProvider';

/**
 * PATCH /v1/superadmin/leads/:id/fields — the Batch grid's inline edit,
 * cross-tenant (viq-vault spec 2026-09-17, viq-backend#117). Keyed by lead id
 * only (no ?companyId=), like the console's other lead routes. Sends only the
 * fields being changed: no `expectedVersion` (per-field last-write-wins) and
 * never `displayName` (server-derived; the key 400s). Server gate:
 * `requireAbility('update', 'Lead')`, one write token per call.
 *
 * Same contract as the portal twin (`apps/portal/src/api/leadFields.ts`),
 * including the thrown error's `retryAfter` on a 429 — which this app's
 * `fetchJson` now carries too, so both SPAs back off the same way.
 */
export function patchLeadFields(
  leadId: string,
  patch: LeadFieldsPatch,
): Promise<LeadFieldsUpdateResponse> {
  return superadminFetch<LeadFieldsUpdateResponse>(`/v1/superadmin/leads/${leadId}/fields`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
}
